import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GoogleChartComponent } from 'angular-google-charts';
declare var google:any;
@Component({
  selector: 'app-graf-skladisce-primerjava-plan-gauge',
  templateUrl: './graf-skladisce-primerjava-plan-gauge.component.html',
  styleUrls: ['./graf-skladisce-primerjava-plan-gauge.component.css']
})
export class GrafSkladiscePrimerjavaPlanGaugeComponent implements OnInit {
  @ViewChild('googlechart', {static: false}) public googlechart: GoogleChartComponent;
  @Input() compareCalc;
  public chart = {
    title: 'Procent',
    type: 'Gauge',
    data: [
      ['Memory', 50]
    ],
    options: {
      greenFrom: 100,
      greenTo: 200,
      redFrom: 0,
      redTo: 49,
      yellowFrom: 50,
      yellowTo: 99,
      minorTicks: 5,
      max: 200
    }
  };
  public data = ([
    ['Label', 'Value'],
    ['Memory', '']
  ]);
  public gaugeType = "arch";
  public gaugeValue = 0;
  public gaugeLabel = "Odstotek prodaje";
  public gaugeAppendText = "%";
  public thresholdConfig = {
    '0': {color: 'red'},
    '50': {color: 'orange'},
    '100': {color: 'green'}
};
public max = 200;
  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes)
    if(changes.compareCalc){
      if(changes.compareCalc.currentValue != undefined || changes.compareCalc.currentValue != null) {
        //console.log(changes.compareCalc.currentValue)
        google.charts.load('current', {'packages':['gauge']}).then(function () {
          // get data
          //console.log(changes.compareCalc.currentValue)
          drawChart(changes.compareCalc.currentValue);
        });
      }
    }

    function drawChart(compareCalc) {
      //console.log(compareCalc);
       var data = google.visualization.arrayToDataTable([
         ['Label', 'Value'],
         ['Plan %', compareCalc]
       ]);

       var options = {
        greenFrom: 100,
        greenTo: 200,
        redFrom: 0,
        redTo: 49,
        yellowFrom: 50,
        yellowTo: 99,
        minorTicks: 5,
        max: 200
      };

       var chart = new google.visualization.Gauge(document.getElementById('chart_div_plan'));

       chart.draw(data, options);

    }
  }

  ngOnInit() {

  }


}
